const routes = [
  {
    // 南京兴业国庆数币活动-首页
    path: '/nanjingXingyeNationalDayCoins',
    name: 'nanjingXingyeNationalDayCoins',
    component: () => import('@/views/industrialBank/nanjingXingyeNationalDayCoins/index.vue'),
    meta: {
      requiresAuth: true,
      title: '南京兴业国庆数币活动'
    }
  },

  {
    // 江苏兴业数币抽奖活动-首页
    path: '/jiangsuDigitalCoinLotteryIndex',
    name: 'jiangsuDigitalCoinLotteryIndex',
    component: () => import('@/views/industrialBank/jiangsuDigitalCoinLottery/index.vue'),
    meta: {
      requiresAuth: true,
      title: '兴业银行'
    }
  },
  {
    // 江苏兴业数币抽奖活动-图例
    path: '/jiangsuDigitalCoinLotteryStep',
    name: 'jiangsuDigitalCoinLotteryStep',
    component: () => import('@/views/industrialBank/jiangsuDigitalCoinLottery/stepLongDiagram.vue'),
    meta: {
      requiresAuth: false,
      title: '兴业银行'
    }
  },
  {
    // 兴业新户数币红包抽奖-首页
    path: '/newAccountDigitalLottery',
    name: 'newAccountDigitalLottery',
    component: () => import('@/views/industrialBank/newAccountDigitalLottery/index.vue'),
    meta: {
      requiresAuth: true,
      title: '兴业银行'
    }
  },

]

export default routes
